export const ROTULOS_TIPO_SUPORTE = {
    duvida: "Tirar uma dúvida",
    sugestao: "Sugerir funcionalidade",
    problema: "Reportar problema",
};
export const ROTULOS_STATUS_SUPORTE = {
    aguardando_rascunho: "Estamos analisando",
    aguardando_revisao: "Em revisão",
    aguardando_usuario: "Respondido",
    concluido: "Concluído",
};
export function tipoChamadoSuporte(valor) {
    return valor === "duvida" || valor === "sugestao" || valor === "problema"
        ? valor : null;
}
export function textoSuporte(valor, limite = 4_000) {
    return typeof valor === "string"
        ? valor.replace(/[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g, "")
            .trim().slice(0, limite)
        : "";
}
//# sourceMappingURL=suporte.js.map